<script lang="ts">
    export let isCustomerContent: boolean;
</script>

{#if isCustomerContent}
    <slot name="customer-content" />
{:else}
    <slot name="default-content" />
{/if}
